/**
 * Utilidades de fechas.
 *
 * BUG que corregimos aquí: `new Date("2026-09-05")` en JavaScript se
 * interpreta como UTC medianoche. Al renderizar en zona `America/Santiago`
 * (UTC-3/-4) retrocede al día anterior. Todos los helpers de este archivo
 * parsean primero cuando reciben un string con formato `YYYY-MM-DD` y
 * construyen la fecha como LOCAL para que el día seleccionado por el usuario
 * sea exactamente el día que se muestra.
 */

/**
 * Devuelve un objeto Date en zona horaria LOCAL cuando recibe un string
 * `YYYY-MM-DD` (sin hora). Para timestamps ISO completos (con `T` u offset)
 * delega en el constructor normal.
 */
export function parseLocalDate(input) {
  if (input == null) return null;
  if (input instanceof Date) return input;
  const s = String(input);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/**
 * Formatea una fecha a locale es-CL sin desfase por zona horaria.
 * @param {string|Date|null|undefined} input ISO/YYYY-MM-DD/Date
 * @param {Intl.DateTimeFormatOptions} [options]
 * @param {string} [fallback="—"] cadena a devolver si `input` es nulo/inválido
 */
export function fmtDate(input, options, fallback = "—") {
  const d = parseLocalDate(input);
  if (!d) return fallback;
  return d.toLocaleDateString("es-CL", options);
}

/**
 * Formatea fecha + hora. Útil para timestamps completos donde SI queremos ver
 * la hora. NUNCA aplica shift a YYYY-MM-DD porque en ese caso solo hay día.
 */
export function fmtDateTime(input, options = { dateStyle: "medium", timeStyle: "short" }, fallback = "—") {
  const d = parseLocalDate(input);
  if (!d) return fallback;
  return d.toLocaleString("es-CL", options);
}

/**
 * Edad en años cumplidos a partir de una fecha de nacimiento
 * (ISO o `YYYY-MM-DD`). Devuelve `null` si la fecha no es válida.
 */
export function calcAge(birthDate) {
  const b = parseLocalDate(birthDate);
  if (!b) return null;
  const t = new Date();
  let age = t.getFullYear() - b.getFullYear();
  const m = t.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && t.getDate() < b.getDate())) age--;
  return age >= 0 && age < 120 ? age : null;
}
